// NPM Import
import React, { Fragment, Component } from "react";
import Select, { components } from "react-select";

// Component Imports
import PlanUpgrade from "../../../PlanUpgrade";

const { Option } = components;
const UpgradeOption = props => (
  <Option {...props}>
    {props.data.label}
    {props.data.label === "User" && <PlanUpgrade />}
  </Option>
);

export default class UserRoleSelectInSettingPageUpgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionData: this.convertIntoKeyValue(props.roles),
    };
  }

  convertIntoKeyValue = options => {
    const data = [];
    options.forEach(element => {
      data.push({
        value: element.name,
        label: element.name,
      });
    });
    return data;
  };

  _onSelectChange = value => {
    if (value.label === "User") {
      this.setState({
        showPopUp: true,
      });
    } else {
      this.props.onSelectChange("userRole", value.value);
    }
  };

  togglePopUp = () => {
    this.setState({
      showPopUp: false,
    });
  };

  toggleUpgradeModal = () => {
    this.setState({
      showPopUp: false,
    });
  };

  render() {
    return (
      <Fragment>
        <div className="inviteteammatespopup-form-field">
          <div className="addproduct-div-wrapper">
            <span className="addproduct-label">
              {this.props.title}
              <span className="required-input">*</span>
            </span>
            <Select
              components={{ Option: UpgradeOption }}
              options={this.state.optionData}
              onChange={value => this._onSelectChange(value)}
              value={this.props.optionData}
              data-test="productconfigurationselectupgrade-select"
            />
          </div>
        </div>
        {this.state.showPopUp && (
          <PlanUpgrade
            type={this.props.featureName}
            smallBtn
            showPopUp={this.state.showPopUp}
            onClose={() => this.toggleUpgradeModal(false)}
          />
        )}
      </Fragment>
    );
  }
}
